<div mat-dialog-title>
    <div class="row">
        <h4 class="col-8">Are you sure you want to delete this document?</h4>
        <span class="col-4 text-right">
            <button mat-icon-button class="close-icon" [mat-dialog-close]="false">
                <i class="fas fa-times"></i>
            </button>
        </span>
    </div>
</div>
<div mat-dialog-content>
    <p>Are you sure you wish to delete this document?</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkfocusinitial>Delete</button>
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
</div>
